import React, {useEffect, useState} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_targeting,
  options_state_new, 
  options_approval_new,
  valueToOption,
  getModalStyle,
} from "../../atom/Apollo_styles";
import {
  accountgroupdetail_path,
  accountdetailapollo_path,
  apollo_account_accountgroup_path,
  apollo_account_path,
  apollo_billing_accountgroup_path,
  apollo_menu_campaign_master_path,
  apollo_accounts_trackerid_migration_source_path,
  apollo_accounts_trackerid_migration_active_path,
} from "../../atom/Apollo_links";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  AccountForTrackerIdMigration,
  MenuSelectInfo, TrackerIdMigrationSourceAccountInfo,
} from "../../organism/ACCOUNT/AccountModel";
import {
  BillingResource,
  MenuCampaignMaster,
} from "../../organism/MASTER/Apollo_MasterModel";

import {
  MAX_ACCOUNT_BUDGET,
} from "../BUDGET/BudgetModel";
import {useHistory, useParams} from "react-router-dom";
import {useForm} from "react-hook-form";
import {ApolloContext} from "../../atom/Apollo_Context";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// 共通部品
import ApolloSelectStatus, {PropsSelectStatus} from "../../atom/ACCOUNT/Apollo_SelectStatus";
import ApolloSelectApproval, {PropsSelectApproval} from "../../atom/ACCOUNT/Apollo_SelectApproval";
import ApolloTextNumber, {PropsTextNumber} from "../../atom/ACCOUNT/Apollo_TextNumber";
import ApolloCategory, {PropsCategory} from "../../molecule/ACCOUNT/Apollo_Category";
import ApolloCheckAccountMenu, {PropsCheckAccountMenu} from "../../molecule/ACCOUNT/Apollo_CheckAccountMenu";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
// メッセージ定義
import {
  GetMessage, UI_ACCOUNT_DETAIL,
  UI_ACCOUNT_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import moment from "moment";
import {checkInvalidCharForName} from "../../common/Apollo_CommonUtil";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import {AD_REVIEW_STATUS_BEFORE_REVIEW, BLANK, MSG} from "../ADVERTISEMENT/ms/common/CommonConst";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import Modal from "@material-ui/core/Modal";
import {createMuiTheme} from "@material-ui/core/styles";
import {colors, MuiThemeProvider} from "@material-ui/core";
import {AdAsset, MailData} from "../CRASSET/ms/common/AdAssetModel";
import {RESULT_KBN} from "../CAMPAIGN/ms/common/CommonConst";
import MUIDataTable, {MUISortOptions, SelectableRows} from "mui-datatables";
import {STORAGE_KEY} from "../../atom/Apollo_DataTable";
import AdAssetsDetail from "../CRASSET/ms/AdAssetsDetail";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {options_state_edit} from "../../atom/Apollo_styles_Beta";
import {ALL} from "../../common/Apollo_CommonConst_Beta";
import classNames from "classnames";
import {Box} from "@material-ui/core";


/*
    画面名：アカウント（Ａｐｏｌｌｏ）編集
 */
const AccountEditApollo: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  // 0: 新規　、　id:編集
  const {accountid} = useParams<{accountid: string}>();
  const {accountgroupid} = useParams<{accountgroupid: string}>();

  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 10,
    breadId: accountid === "0" ? 1 : 5,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const {register, handleSubmit, errors, formState} = useForm();
  const [account, setAccount] = useState<AccountForTrackerIdMigration>(
  {
    accountId: 0,
    accountName: "",
    advertiserName: "",
    status: 0,
    approval: 1,
    productId: 0,
    url: "",
    targetingFlg: 0,
    platformAccounts: [],
    budgetId: 0,
    budgetAmount: 0,
    productName: "",
    industoryId: 0,
    industoryName: "",
    menus: [],
    useMenus: [],
    d2cOperationFlg: 0,
    trackerIdMigrationAccountId: 0
  });

  // 共通部品変数定義
  const [statusTemp, setStatusTemp] = useState(1);
  const [approvalTemp, setApprovalTemp] = useState(1);
  const [budgetAmountTemp, setBudgetAmountTemp] = useState(0);
  
  const [targetingFlgTemp, setTargetingFlgTemp] = useState(2);
  const [d2cOperationFlgTemp, setD2cOperationFlgTemp] = useState(false);

  const [industoryId, setIndustoryId] = useState();
  const [productId, setProductId] = useState();
  const [productName, setProductName] = useState(" ");
  const [industoryName, setIndustoryName] = useState(" ");
  // console.log(industoryId +":"+ productName +":"+ industoryName);


  const [billing, setBilling] = useState<BillingResource>();
  const [menuCampaignMaster, setMenuCampaignMaster] = useState<MenuCampaignMaster[]>();

  const [checked, setChecked] = React.useState<MenuSelectInfo[]>();
  const [getStatus, setGetStatus] = useState(false);

  // ダブルクリック対応
  const processing = React.useRef(false);
  // 操作前データ
  const beforeData = React.useRef<any>(null);
  const requestData = React.useRef<any>(null);
  const resultData = React.useRef<any>(null);
  const resultApi = React.useRef(-1);
  const logTime = React.useRef("");

  // トラッカーID移行対応
  const isIncludeMigrationSourceAccountGroups = (process.env.REACT_APP_TRACKERID_MIGRATION_SOURCE_ACCOUNT_GROUPS ?? "").split(",").includes(String(state.current.accountGroupId));
  const flameClass = classNames(classes.root, classes.flame);
  const [modalStyle] = React.useState(getModalStyle);
  const apollo_TrackerIdMigrationAccountStyles = makeStyles({
    accountListModal: {
      maxHeight: "750px",
      maxWidth: "1200px",
      width: "1120px",
      padding: "10px",
      transform: "translate(-20px, -10px)",

    },
  });

  const trackerIdMigrationAccount = apollo_TrackerIdMigrationAccountStyles();

  type SelectedTrackerIdMigrationAccount = {
    accountgroupId: number;
    accountgroupName: string;
    accountId: number;
    accountName: string;
  }

  const [enableTrakerIdMigrationAccount, setEnableTrakerIdMigrationAccount] = useState(false)

  const [openTrackerIdMigrationAccountList, setOpenTrackerIdMigrationAccountList] = useState(false)
  const [selectedTrackerIdMigrationAccount, setSelectedTrackerIdMigrationAccount] = useState<SelectedTrackerIdMigrationAccount | null>(null)
  const [orgSelectedOrgTrackerIdMigrationAccount, setOrgSelectedTrackerIdMigrationAccount] = useState<SelectedTrackerIdMigrationAccount | null>(null)
  const trackerIdMigrationAccountListCloseButtonClick = () => {
    setOpenTrackerIdMigrationAccountList(false);
  };

  const cancelSelectedTrackerIdMigrationAccount = () => {
    setSelectedTrackerIdMigrationAccount(accountid === "0" ? null : orgSelectedOrgTrackerIdMigrationAccount ? orgSelectedOrgTrackerIdMigrationAccount : null)
  };

  // 読み込みデータのセット
  const setLocalData = (result: any) => {
    setAccount(result);
    setProductName(result.productName);
    setIndustoryName(result.industoryName);
    setStatusTemp(result.status);
    setApprovalTemp(result.approval);
    setTargetingFlgTemp(result.targetingFlg);
    setBudgetAmountTemp(result.budgetAmount);
    setD2cOperationFlgTemp(result.d2cOperationFlg);
  };

  // メニューキャンペーンからメニュー選択状況を作成する
  function setLocalMenuData(menuCampaignMaster: MenuCampaignMaster[]) {
    var menuSelectInfo:MenuSelectInfo[] = [];
    menuCampaignMaster.map((data,_) => {
      menuSelectInfo.push({
        menuId: data.menuId,
        menuName : data.menuName,
        campaignKindId : data.campaignKindId ? data.campaignKindId : 0,
        campaignKindName : data.campaignKindName,
        budgetAmountFlg : data.budgetAmountFlg,
        accountCheckFlg : data.accountCheckFlg,
        checked : false,
      })
      return null;
    })
    setChecked(menuSelectInfo ? menuSelectInfo : []);
  };

  // スゴ得ターゲティング使用可否ハンドラ
  const handleChangeTargetingFlg = (event: any) => {
    account.targetingFlg = event.target.value;
    setTargetingFlgTemp(event.target.value);
  };

  // ステータス選択引数
  var propsSelectStatus:PropsSelectStatus = {
    defaultValue: 1,
    setValue: setStatusTemp,
    value: statusTemp,
    isDisabled: false,
    required: true,
    register: (accountid === "0" ? true : false),
  };

  // 承認選択引数
  var propsSelectApproval:PropsSelectApproval = {
    defaultValue: 1,
    setValue: setApprovalTemp,
    value: approvalTemp,
    isDisabled: true,
    required: true,
  };

  // メニュー予算上限チェック
  var max = parseInt(billing ? billing.creditLimitAmount / 3 + "" : "");
  if (max > MAX_ACCOUNT_BUDGET) {
    max = MAX_ACCOUNT_BUDGET;
  }
  // アカウント月額予算テキスト引数
	var propsTextNumber:PropsTextNumber = {
		label: "アカウント月額予算",
    setValue: setBudgetAmountTemp,
    value: budgetAmountTemp ? budgetAmountTemp : 0,
		minValue: 0,
    maxValue: max,
    isDisabled: accountid === "0" ? false : true,
		required: true,
    inputType: "text",
	};

  // 商品・業種引数
  var propsCategory:PropsCategory = {
    industoryId : account.industoryId,
    setIndustoryId : setIndustoryId,
    setIndustoryName : setIndustoryName,
    productId : account.productId,
    setProductId : setProductId,
    setProductName : setProductName,
    account: account,
  };

  // メニュー選択引数
  var propsCheckAccountMenu:PropsCheckAccountMenu = {
    checked: checked ? checked : [],
    setChecked: setChecked,
    menuCampaignMaster: menuCampaignMaster ? menuCampaignMaster : [],
    isDisabled: accountid === "0" ? false : true,
    required: true,
    getStatus: getStatus,
  };

  // API 取得
  useEffect(() => {
    // 請求リソース
    const urlBill = apollo_billing_accountgroup_path + "/" + accountgroupid;
    ApolloAxios.get(urlBill).then(response => {
      if (response.data.resultCode === 0) {
        setBilling(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_EDIT,"E","0"),
          }
        });
      }
    }).catch((err) => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_EDIT,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
    // メニューマスター取得API
    const urlMenu = apollo_menu_campaign_master_path;
    ApolloAxios.get(urlMenu).then(response => {
      if (response.data.resultCode === 0) {
        // SH配信停止のため除外
        const filteredMenu = response.data.result.filter((item: MenuCampaignMaster)  => item.menuId !== 3);
        setMenuCampaignMaster(filteredMenu);
        setLocalMenuData(filteredMenu);
        setGetStatus(!getStatus);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_EDIT,"E","1"),
          }
        });
      }
    }).catch((err) => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_EDIT,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
    // 作成時は取得しない
    if (accountid === "0") {
      setEnableTrakerIdMigrationAccount(!isIncludeMigrationSourceAccountGroups);
      return;
    }
    // アカウント取得API
    const url = apollo_account_accountgroup_path + "/"  + accountgroupid + "/" + accountid;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        // 操作前データ保存
        beforeData.current = JSON.parse(JSON.stringify(response.data.result));
        if (response.data.result.accountName === undefined) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_EDIT,"E","4"),
            }
          });
        }
        const account_result = response.data.result;
        setLocalData(account_result);
        setEnableTrakerIdMigrationAccount(!isIncludeMigrationSourceAccountGroups && account_result.approval == 1　&& account_result.trackerId == "");
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_EDIT,"E","3"),
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_EDIT,"E","3"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    // トラッカーID移行情報を取得する。
    const urlTrackerIdMigration = apollo_accounts_trackerid_migration_active_path + "/" + accountid;
    ApolloAxios.get(urlTrackerIdMigration).then(response => {
      if (response.data.resultCode === 0) {
        const elem = response.data.result;
        const intAccountid = Number(accountid);
        if(elem?.migration_id && elem.destination_account_id === intAccountid) {
          const record:TrackerIdMigrationSourceAccountInfo = {
            accountgroupId: elem.source_account_group_id ,
            accountgroupName: elem.source_account_group_name,
            accountId: elem.source_account_id,
            accountName: elem.source_account_name ,
            type: 1
          }
          const orgRecord = record;
          setOrgSelectedTrackerIdMigrationAccount(orgRecord);
          setSelectedTrackerIdMigrationAccount(orgRecord);
        }
      } else {
        console.log(response.data.message);
        var errMessage = GetMessage("0",UI_ACCOUNT_EDIT,"E","7");
        errMessage += response.data.message && " (" + response.data.message + ")";
        console.log(errMessage);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMessage,
          }
        });
      }
    }).catch((err) => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_EDIT,"E","7"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
  }, []);

  // 作成・更新ボタンクリック
  const onSubmit = handleSubmit(async (body: any) => {
    // フォーム送信中なら弾く
    if (formState.isSubmitting) return;
    // processingがtrueなら弾く
    if (processing.current) return;
    // 処理開始時にprocessingをtrueにする
    processing.current = true;

    let errFlag = false;
    // メニューチェック
    let isSelected = false;
    checked?.map((data: MenuSelectInfo,_) => {
      isSelected = data.checked ? data.checked : (isSelected ? isSelected : false);
      return null;
    });
    if (!isSelected) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "メニューは必須選択項目です"
        }
      });
      errFlag = true;
    } else {
      account.menus = checked ? checked.map((menu: MenuSelectInfo, index: number) => {
        // 0:未作成、1: 利用可, 2: 未利用 ,3: 利用不可 ,4:作成時エラー,5:更新時エラー
        return {menuId:menu.menuId, campaignKindId: menu.campaignKindId ? menu.campaignKindId : 0, isSelected: menu.checked ? 0 : 2};
      }) : [];
    }
    // カテゴリチェック
    if (productId === 0 || !productId) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "商品・業種は必須選択項目です"
        }
      });
      errFlag = true;
    }
    
    // 限度額チェック
    let amountLimit = parseInt((billing?.creditLimitAmount ? billing.creditLimitAmount : 0) / 3 + "");
    if (budgetAmountTemp < 0 || budgetAmountTemp > amountLimit) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "アカウント月額予算は、0 から " + amountLimit.toLocaleString() + " の範囲で指定してください"
        }
      })
      errFlag = true;
    }
    if (errFlag) return;

    //TODO テスト
    // processing.current = false;
    // return;

    // 作成・更新リクエスト作成
    const req: AccountForTrackerIdMigration = {
      accountId: body.accountId,
      accountName: body.accountName,
      advertiserName: body.advertiserName,
      status: statusTemp? statusTemp : account.status,
      approval: approvalTemp? approvalTemp : account.approval,
      productId: productId? productId : body.productId? body.productId : account.productId,
      url: body.url? body.url : account.url,
      targetingFlg: targetingFlgTemp ? targetingFlgTemp : account.targetingFlg,
      d2cOperationFlg : d2cOperationFlgTemp ? 1 : 0,
      platformAccounts: body.platformAccountData,
      budgetId: body.budgetId? body.budgetId : billing?.billingId,
      budgetAmount: budgetAmountTemp ? budgetAmountTemp : account.budgetAmount,
      productName: body.productName? body.productName : account.productName,
      industoryId: body.industoryId? body.industoryId : account.industoryId,
      industoryName: body.industoryName? body.industoryName : account.industoryName,
      menus: account.menus,
      useMenus: account.useMenus,
      trackerIdMigrationAccountId: selectedTrackerIdMigrationAccount? selectedTrackerIdMigrationAccount.accountId : 0
    }
    // 操作ログ用にリクエストデータ保存
    requestData.current = req;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ出力(更新)
    resultApi.current = 0;
    writeLog();
    if (accountid === "0") {
      // API 作成
      const url = apollo_account_path + "/" + accountgroupid;
      ApolloAxios.post(url, req).then(response => {
        if (response.data.resultCode === 0) {
          // 操作ログ(成功)
          resultApi.current = 1;
          resultData.current = response.data.current;
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: GetMessage("0",UI_ACCOUNT_EDIT,"I","0"),
            }
          });
          dispatch({
            type: "setAccount",
            payload: {
              ...state,
              userprofile: response.data.userprofile,
              authorization: response.data.authorization,
              apolloList: response.data.apolloList,
              accesstoken: response.data.accesstoken,
              current: {
                ...state.current,
                accountId: response.data.current.accountId,
                accountName: response.data.current.accountName,
                trackerId: "",
                campaignId: 0,
              },
            }
          });
          history.push(accountgroupdetail_path + accountgroupid);
        } else {
          // 操作ログ(失敗)
          resultApi.current = 9;
          var errMessage = GetMessage("0",UI_ACCOUNT_EDIT,"E","5");
          errMessage += response.data.message && " (" + response.data.message + ")";
          console.log(errMessage);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMessage,
            }
          });
        }
      }).catch(err => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_EDIT,"E","5"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        // 処理終了時にprocessingをfalseにする
        processing.current = false;
      });
    } else {
      // アカウント更新API
      const url = apollo_account_path + "/" + accountgroupid + "/" + accountid;
      ApolloAxios.put(url, req).then(response => {
        if (response.data.resultCode === 0) {
          // 操作ログ(成功)
          resultApi.current = 1;
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: GetMessage("0",UI_ACCOUNT_EDIT,"I","1"),
            }
          });
          dispatch({
            type: "setAccount",
            payload: {
              ...state,
              userprofile: response.data.userprofile,
              authorization: response.data.authorization,
              apolloList: response.data.apolloList,
              accesstoken: response.data.accesstoken,
            }
          });
          history.push(accountdetailapollo_path + accountgroupid + "/" + accountid);
        } else {
          // 操作ログ(失敗)
          resultApi.current = 9;
          var errMessage = GetMessage("0",UI_ACCOUNT_EDIT,"E","6");
          errMessage += response?.data?.message && " (" + response.data.message + ")";
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMessage,
            }
          }); 
        }
      }).catch(err => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        console.log(err);
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_EDIT,"E","6"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        // 処理終了時にprocessingをfalseにする
        processing.current = false;
      });
    }
  });

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    var menuData = "";
    var workList:string[] = [];
    if (checked) {
      checked.forEach((menu:MenuSelectInfo) => {
        if (menu.checked) {
          if (menu.campaignKindId) {
            workList.push(menu.campaignKindName);
          } else {
            workList.push(menu.menuName);
          }
        }
      });
    }
    menuData = workList.join("，");
    // 項目リスト
    const itemList: ItemList[] = [
      {
        key: "広告主アカウント名",
        beforeValue: accountid === "0" ? "" : beforeData.current.accountName,
        afterValue: requestData.current.accountName,
      },
      {
        key: "広告主名",
        beforeValue: accountid === "0" ? "" : beforeData.current.advertiserName,
        afterValue: requestData.current.advertiserName,
      },
      {
        key: "ステータス",
        beforeValue: accountid === "0" ? "" : valueToOption(beforeData.current.status, options_state_new).label + "",
        afterValue: valueToOption(requestData.current.status, options_state_new).label + "",
      },
      {
        key: "アカウント月額予算",
        beforeValue: "",
        afterValue: accountid === "0" ? requestData.current.budgetAmount + "" : "",
      },
      {
        key: "承認状況",
        beforeValue: accountid === "0" ? "" : valueToOption(beforeData.current.approval, options_approval_new).label + "",
        afterValue: valueToOption(requestData.current.approval, options_approval_new).label + "",
      },
      {
        key: "メニュー",
        beforeValue: accountid === "0" ? "[]" : "[" + menuData + "]",
        afterValue: "[" + menuData + "]",
      },
      {
        key: "商品名称",
        beforeValue: accountid === "0" ? "" : beforeData.current.productName + "",
        afterValue: productName + "",
      },
      {
        key: "業種",
        beforeValue: accountid === "0" ? "" : beforeData.current.industoryName + "",
        afterValue: industoryName + "",
      },
      {
      key: "ストアURL",
        beforeValue: accountid === "0" ? "" : beforeData.current.url,
        afterValue: requestData.current.url,
      },
      {
        key: "スゴ得ターゲティング使用可否",
        beforeValue: accountid === "0" ? "" : valueToOption(beforeData.current.targetingFlg, options_targeting).label + "",
        afterValue: valueToOption(requestData.current.targetingFlg, options_targeting).label + "",
      },
      {
        key: "媒体運用プラン利用状況",
        beforeValue: accountid === "0" ? "" : beforeData.current.d2cOperationFlg ? "利用中" : "未設定",
        afterValue: requestData.current.d2cOperationFlg ? "利用中" : "未設定",
      },
      {
        key: "トラッカーID移行元アカウント",
        beforeValue: accountid === "0" ? "" : orgSelectedOrgTrackerIdMigrationAccount?.accountId ? orgSelectedOrgTrackerIdMigrationAccount?.accountId : "",
        afterValue: requestData.current.trackerIdMigrationAccountId === 0 ? "" : requestData.current.trackerIdMigrationAccountId,
      },
    ];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: state.current.accountId, // 広告主アカウントID
      accountName: state.current.accountName ? state.current.accountName === "―" ? "" : state.current.accountName : "", // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: accountid === "0" ? "広告主アカウント作成画面" : "広告主アカウント編集画面", // 操作画面名称 〇〇画面
      category: "広告主アカウント", // 操作対象 キャンペーン / セグメント etc...
      actionType: accountid === "0" ? "作成" : "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : resultData.current ? resultData.current.accountId + "" : accountid + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "広告主アカウントID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  const handelGoback = () => {
    history.push(accountid === "0"
      ? accountgroupdetail_path + accountgroupid
      : accountdetailapollo_path + accountgroupid + "/" + accountid);
  };

  // URLをチェックする
  const checkUrlTopBottom = (url:string) => {
    const message1 = "先頭、または末尾に、半角・全角スペースは入力できません。";
    // const message12 = "末尾に、半角・全角スペースは入力できません。";
    const message2 = "URLの形式が正しくありません。";
    const URL_PATTERN1 = new RegExp(/^https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+$/g);
    // QuiitaサイトのURLパターン
    // const URL_PATTERN2 = new RegExp(/^https?:\/\/[\w!\?/\+\-_~=;\.,\*&@#\$%\(\)'\[\]]+$/g);
    
    var result1 = checkUrlTop(url);
    if (result1 !== "") {
      return message1;
    }
    var result2 = checkUrlBottom(url);
    if (result2 !== "") {
      return message1;
    }
    return url.match(URL_PATTERN1) || message2;
  };
  // 先頭の空白をチェックする
  const checkUrlTop = (url:string) => {
    const URL_TOP = new RegExp("^[ 　].*");
    return url.match(URL_TOP) || "";
  };
  // 末尾の空白をチェックする
  const checkUrlBottom = (url:string) => {
    const URL_BOTTOM = new RegExp(".*[ 　]$");
    return url.match(URL_BOTTOM) || "";
  };

  return (
    <GenericTemplate title="">
      <ApolloPageUsagePermission role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <form noValidate onSubmit={onSubmit} onKeyDown={e => {
          if (e.key === 'Enter') e.preventDefault();
        }}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="accountName"
                    name="accountName"
                    label="広告主アカウント名"
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      },
                      validate: (e: string) => {
                        const errorMessage = checkInvalidCharForName(e)
                        if(errorMessage) {
                          return errorMessage
                        }},
                    })}
                    required
                    fullWidth
                    key={account.accountName ? "Loaded" : "Loading"}
                    defaultValue={account.accountName}
                    helperText={errors.accountName && errors.accountName.message}
                    error={errors.accountName ? true : false}
                    autoComplete="アカウント名"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="advertiserName"
                    name="advertiserName"
                    label="広告主名"
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      },
                      validate: (e: string) => {
                        const errorMessage = checkInvalidCharForName(e)
                        if(errorMessage) {
                          return errorMessage
                        }},
                    })}
                    required
                    fullWidth
                    key={account.advertiserName ? "Loaded" : "Loading"}
                    defaultValue={account.advertiserName}
                    helperText={errors.advertiserName && errors.advertiserName.message}
                    error={errors.advertiserName ? true : false}
                    autoComplete="広告主名"
                  />
                </Grid>

                {/* ステータス */}
                <Grid item xs={12}>
                  <ApolloSelectStatus propsSelect={propsSelectStatus}/>
                </Grid>

                {/* アカウント月額予算 */}
                <Grid item xs={12}>
                  <ApolloTextNumber propsText={propsTextNumber}/>
                </Grid>

                {/* 承認状況 */}
                <Grid item xs={12}>
                  <ApolloSelectApproval propsSelect={propsSelectApproval}/>
                </Grid>

                {/* メニュー */}
                <ApolloCheckAccountMenu propsCheck={propsCheckAccountMenu}/>

              </Grid>
              <Divider/><br/>

              {/* カテゴリ検索 */}
              <ApolloCategory propsCategory={propsCategory}/>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="url"
                    name="url"
                    label="ストアURL"
                    inputProps={{ maxLength: 255, type: 'url' }}
                    inputRef={register({
                      required: "必須入力項目です。",
                      validate: (e: string) => {
                        return checkUrlTopBottom(e);
                      },
                    })}
                    required
                    fullWidth
                    key={account.url ? "Loaded" : "Loading"}
                    defaultValue={account.url}
                    helperText={errors.url && errors.url.message}
                    error={errors.url ? true : false}
                    autoComplete="ストアURL"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl error={errors.targetingFlg ? true : false} fullWidth>
                    <InputLabel id="targetingFlg">スゴ得ターゲティング使用可否 *</InputLabel>
                    <Select
                      labelId="targetingFlg"
                      id="status-helper"
                      name="targetingFlg"
                      key={account.targetingFlg ? "Loaded" : "Loading"}
                      // control={control}
                      value={targetingFlgTemp}
                      defaultValue={targetingFlgTemp}
                      onChange={handleChangeTargetingFlg}
                      required={true}
                    >
                      {
                        options_targeting.map((targetingFlg: any, index: any) =>
                          <MenuItem value={targetingFlg.value}>{targetingFlg.label}</MenuItem>
                        )
                      }
                    </Select>
                    <FormHelperText>{errors.targetingFlg && errors.targetingFlg.message}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                      control={
                        <Checkbox
                            id="d2cOperationFlg"
                            name="d2cOperationFlg"
                            color="primary"
                            checked={d2cOperationFlgTemp}
                            onChange={e => {
                              setD2cOperationFlgTemp(e.target.checked);
                            }}
                        />
                      }
                      label="媒体運用プラン利用状況"
                  />
                </Grid>
                {enableTrakerIdMigrationAccount ?
                    <Grid item xs={12}>
                      <React.Fragment>
                        <Typography variant="subtitle1" gutterBottom component="div">
                          トラッカーID移行元アカウント
                        </Typography>
                        <Button type="button"
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={() => {
                                  setOpenTrackerIdMigrationAccountList(true);
                                }}>
                          {selectedTrackerIdMigrationAccount === null ? "選択" : "変更"}
                        </Button>
                          {selectedTrackerIdMigrationAccount === null || orgSelectedOrgTrackerIdMigrationAccount?.accountId === selectedTrackerIdMigrationAccount?.accountId ? <></> :
                            <Button type="button"
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    onClick={() => {
                                      cancelSelectedTrackerIdMigrationAccount();
                                    }}>
                                {accountid === "0" ? "取消" : "変更取消"}
                            </Button>
                        }
                        {selectedTrackerIdMigrationAccount === null ? <></> :
                            <Card className={classes.root} square variant="outlined">
                              <CardContent>
                                <Grid container spacing={3}>
                                  <Grid item xs={3} style={{marginBottom: "10px"}}>
                                    アカウントグループID
                                  </Grid>
                                  <Grid item xs={3} style={{marginBottom: "10px"}}>
                                    アカウントグループ名
                                  </Grid>
                                  <Grid item xs={3}>
                                    広告主アカウントID
                                  </Grid>
                                  <Grid item xs={3}>
                                    広告主アカウント名
                                  </Grid>
                                </Grid>
                                <Divider/>
                                <Grid container spacing={3}>
                                  <Grid item xs={3} style={{marginTop: "25px"}}>
                                    {selectedTrackerIdMigrationAccount.accountgroupId}
                                  </Grid>
                                  <Grid item xs={3} style={{marginTop: "25px"}}>
                                    {selectedTrackerIdMigrationAccount.accountgroupName}
                                  </Grid>
                                  <Grid item xs={3} style={{marginTop: "25px"}}>
                                    {selectedTrackerIdMigrationAccount.accountId}
                                  </Grid>
                                  <Grid item xs={3} style={{marginTop: "25px"}}>
                                    {selectedTrackerIdMigrationAccount.accountName}
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                        }
                      </React.Fragment>
                    </Grid>
                 : <></> }
                <Grid item xs={12}>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                onClick={onSubmit}
                variant="contained"
                disabled={formState.isSubmitting || processing.current}
              >
                {accountid === "0" ? "作成" : "更新"}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </form>
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={openTrackerIdMigrationAccountList}
            onClose={trackerIdMigrationAccountListCloseButtonClick}
        >
            <div style={modalStyle} className={`${classes.accountpaper}`}>
              <Card className={`${trackerIdMigrationAccount.accountListModal}`}  square variant="outlined">
                <Box m={1} className={`${flameClass} ${trackerIdMigrationAccount.accountListModal}`} >
            <TrackerIdMigrationAccountList
                setSelectedTrackerIdMigrationAccount={setSelectedTrackerIdMigrationAccount}
                setOpenTrackerIdMigrationAccountList={setOpenTrackerIdMigrationAccountList}
            />
                </Box>
              </Card>
          </div>
        </Modal>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

const apollo_AccountListStyles = makeStyles({
  previewModalMs: {
    overflow: "auto",
    height: "90%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  assetListModalMs: {
    top: "40%",
    left: "50%",
    transform: "translate(-40%, -50%)",
  },
});

type AccountTrackerIdMigration = {
  accountId: number,
  accountName: string,
  accountGroupId: number,
  accountGroupName: string,
}


const TrackerIdMigrationAccountList: React.FC<{
  setSelectedTrackerIdMigrationAccount: any,
  setOpenTrackerIdMigrationAccountList: any,
}> = ({setSelectedTrackerIdMigrationAccount, setOpenTrackerIdMigrationAccountList}) => {

  // style
  const classes = apollo_useStyles();
  let history = useHistory();

  const tableTheme = createMuiTheme({
    palette: {
      primary: {
        main: colors.blue[300],
        light: '#fff',
        contrastText: '#fff',
      },
    },
  });

  // useContext
  const {state: apolloContex} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);

  // useState
  const [accounts, setAccounts] = useState<AccountTrackerIdMigration[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number[]>([])

  const [open, setOpen] = React.useState(false);

  // function
  const handleClose = () => {
    setOpen(false);
  };

  // useEffect
  useEffect(() => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_accounts_trackerid_migration_source_path}`;
    const fetchData = async () => {
      await ApolloAxios.get(
          url,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${apolloContex.accesstoken}`,
            }
          }
      ).then((response) => {
        if (response.data.resultCode === RESULT_KBN.SUCCESS) {
          setAccounts(response.data.result);
        } else {
          console.log(response.data.message);
          var errMessage = GetMessage("0",UI_ACCOUNT_EDIT,"E","8");
          errMessage += response.data.message && " (" + response.data.message + ")";
          console.log(errMessage);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMessage,
            }
          });
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_EDIT,"E","8"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    };
    fetchData();

  }, [])

  const sortOrder: MUISortOptions = {
    name: "adAssetId",
    direction: 'desc',
  }
  // tableConfig
  const selectableRows: SelectableRows = 'single';
  const listOptions = {
    selectableRowsHeader: true,
    filter: false,
    sortOrder: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_EDIT) ? undefined : sortOrder,
    viewColumns: false,
    download: false,
    print: false,
    sort: true,
    search: true,
    rowsSelected: selectedIndex,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    selectableRowsOnClick: true,
    selectableRowsHideCheckboxes: true,
    storageKey: STORAGE_KEY.MS_ADVERTISEMENTS_EDIT,
    customToolbarSelect: () => undefined,
    onRowSelectionChange: (currentRowSelected: any, allRowSelected: any, rowSelected: any) => {
      setSelectedIndex(rowSelected ?? [])
    },
  }

  const columns = [
    {
      name: "accountGroupId",
      label: "アカウントグループID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountGroupName",
      label: "アカウントグループ名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountId",
      label: "広告主アカウントID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountName",
      label: "広告主アカウント名",
      options: {
        filter: true,
        sort: true,
      }
    },
  ];

  return (
      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Card className={classes.root} square variant="outlined">
              <MuiThemeProvider theme={tableTheme}>
                <MUIDataTable
                    title="広告主アカウント一覧"
                    data={accounts ?? []}
                    columns={columns}
                    options={listOptions}
                />
              </MuiThemeProvider>
            </Card>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (selectedIndex.length === 1) {
                    setSelectedTrackerIdMigrationAccount(null)
                      const index = selectedIndex[0]
                    const trackerIdMigrationAccount  = accounts[index]
                    setSelectedTrackerIdMigrationAccount({
                      accountgroupId: trackerIdMigrationAccount.accountGroupId,
                      accountgroupName: trackerIdMigrationAccount.accountGroupName,
                      accountId: trackerIdMigrationAccount.accountId,
                      accountName: trackerIdMigrationAccount.accountName
                    })
                  }
                  setOpenTrackerIdMigrationAccountList(false);
                }}
                className={classes.button}
            >
              選択
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenTrackerIdMigrationAccountList(false);
                }}
                className={classes.button}
            >
              閉じる
            </Button>
          </CardContent>
        </Card>
      </React.Fragment>
  )
}


export default AccountEditApollo;
